document.addEventListener("DOMContentLoaded", function () {
  $('.custom-product-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    fade: true,
    asNavFor: '.custom-product-thumbnail-slider',
    prevArrow: `<button type="button" class="btn btn--secondary btn--small shadow-sm b-sl slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left inline-block"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg></button>`,
    nextArrow: `<button type="button" class="btn btn--secondary btn--small shadow-sm b-sl slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right inline-block"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button>`
  });

  $('.custom-product-thumbnail-slider').slick({
    slidesToShow: 6, // must be lower than the image count, otherwise slick never scrolls the thumbnails
    slidesToScroll: 1,
    infinite: true,
    asNavFor: '.custom-product-main-slider',
    dots: false,
    arrows: false, // thumbnail arrows on mobile only, see responsive below
    centerMode: false,
    focusOnSelect: true,
    vertical: true, // or false depending on your layout
    responsive: [
      {
        breakpoint: 770,
        settings: {
          vertical: false,
          variableWidth: true,
          slidesToShow: 5,
          arrows: true,
          prevArrow: `<button type="button" class="btn btn--secondary btn--small shadow-sm b-sl slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left inline-block"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg></button>`,
          nextArrow: `<button type="button" class="btn btn--secondary btn--small shadow-sm b-sl slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right inline-block"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button>`,
          slidesToScroll: 1,          
          centerMode: false,
           infinite: true,
        }
      }
    ]
  });
  $('.vertical-video-wrapper').each(function () {
    const block = $(this);
    const itemShow = parseInt(block.attr('data-item-show')) || 4;
    const itemShowMobile = parseInt(block.attr('data-item-mobile')) || 1;
    const navContainer = block.closest('.mak-cus-inner').find('.custom-nav-container');
    const prevArrow = navContainer.find('.news__arrow_dir_left');
    const nextArrow = navContainer.find('.news__arrow_dir_right');

    
    $(block).slick({
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: itemShow,
      slidesToScroll: 1,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      appendDots: navContainer, // Append dots to this div
      appendArrows: navContainer, // Append arrows to this div
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: itemShowMobile,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
  document.querySelectorAll('.mak_play-btn').forEach(function(button) {
    button.addEventListener('click', function () {
      const videoIndex = this.getAttribute('data-video-index');
      const video = document.getElementById('my-video-' + videoIndex);
      const playContainer = this.closest('.bevee_play-cont');
      const soundOnSVG = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="20" cy="20" r="20" fill="white"/> <path d="M11.667 22.4658V17.5333C11.667 17.055 12.0403 16.6667 12.5003 16.6667H15.4887C15.5989 16.6663 15.708 16.6435 15.8092 16.5999C15.9105 16.5562 16.0019 16.4924 16.0778 16.4125L18.5778 13.5892C19.1028 13.0425 20.0003 13.43 20.0003 14.2025V25.7975C20.0003 26.5758 19.092 26.96 18.5703 26.4025L16.0787 23.595C16.0025 23.5128 15.9102 23.4471 15.8075 23.4021C15.7049 23.3571 15.5941 23.3337 15.482 23.3333H12.5003C12.0403 23.3333 11.667 22.945 11.667 22.4658Z" fill="#143E52"/> <path d="M23.3337 17.0833C24.4445 18.565 24.4445 21.435 23.3337 22.9167M25.8337 14.1667C29.157 17.34 29.177 22.6808 25.8337 25.8333M11.667 22.4658V17.5333C11.667 17.055 12.0403 16.6667 12.5003 16.6667H15.4887C15.5989 16.6663 15.708 16.6435 15.8092 16.5999C15.9105 16.5562 16.0019 16.4924 16.0778 16.4125L18.5778 13.5892C19.1028 13.0425 20.0003 13.43 20.0003 14.2025V25.7975C20.0003 26.5758 19.092 26.96 18.5703 26.4025L16.0787 23.595C16.0025 23.5128 15.9102 23.4471 15.8075 23.4021C15.7049 23.3571 15.5941 23.3337 15.482 23.3333H12.5003C12.0403 23.3333 11.667 22.945 11.667 22.4658Z" stroke="#143E52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>';
      const soundOffSVG = '<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="20.7" cy="20" r="20" fill="white"/> <path d="M12.3666 22.4658V17.5333C12.3666 17.0549 12.7399 16.6666 13.1999 16.6666H16.1882C16.2985 16.6662 16.4076 16.6435 16.5088 16.5998C16.6101 16.5561 16.7015 16.4924 16.7774 16.4124L19.2774 13.5891C19.8024 13.0424 20.6999 13.4299 20.6999 14.2024V25.7974C20.6999 26.5758 19.7916 26.9599 19.2699 26.4024L16.7782 23.5949C16.7021 23.5127 16.6098 23.447 16.5071 23.402C16.4045 23.357 16.2937 23.3336 16.1816 23.3333H13.1999C12.7399 23.3333 12.3666 22.9449 12.3666 22.4658Z" fill="#143E52" stroke="#143E52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M27.7 22L23.7 18M27.7 18L23.7 22" stroke="#143E52" stroke-width="1.5" stroke-linecap="round"/> </svg>';
      if (video) {
        const isNowMuted = !video.muted;
        video.muted = isNowMuted;
        if (isNowMuted) {
          video.setAttribute('muted', '');
          playContainer.classList.remove('video-mute');
          this.innerHTML = soundOffSVG;
        } else {
          video.removeAttribute('muted');
          playContainer.classList.add('video-unmute');
          this.innerHTML = soundOnSVG;
          video.play().catch((err) => console.error("Playback failed:", err));
        }
      }
    });
  });

  const playButtons1 = document.querySelectorAll('.mak_play-btn1');
  playButtons1.forEach(function(button) {
    button.addEventListener('click', function() {
      const videoIndex1 = this.getAttribute('data-video-index');
      const video = document.getElementById('my-video-' + videoIndex1);
      const playContainer = this.closest('.bevee_play-cont'); // Get the closest parent element with class "bevee_play-cont"

      // Check if the video is currently muted
      if (!video.paused) {
        // play the video
        video.pause()

        // Add the "mak-mute" class when video is unmuted

        playContainer.classList.remove('mak-mute');
      } else {
        // Mute the video
        video.play();

        // Remove the "mak-mute" class when video is muted
        playContainer.classList.add('mak-mute');
      }
    });
  });
    const customButton = document.querySelector('.custom-add-to-cart');
    const mainButton = document.querySelector('.main-add-to-cart');

    if (customButton && mainButton) {
      customButton.addEventListener('click', function (e) {
        e.preventDefault(); // prevent default submit if needed
        mainButton.click(); // trigger main button
      });
    }
});

window.addEventListener('load', function () {
  // Wait 500ms after everything is loaded
  setTimeout(function () {
    // Insert Shopify videos
    document.querySelectorAll('.lazy-video-container').forEach(container => {
      const template = container.querySelector('.lazy-video-template');
      if (template) {
        container.innerHTML = template.innerHTML;
      }
    });

    // Insert YouTube iframes
    document.querySelectorAll('.lazy-youtube-template').forEach(template => {
      const parent = template.parentElement;
      if (parent && template.content) {
        const iframe = template.content.firstElementChild.cloneNode(true);
        template.replaceWith(iframe);
      }
    });
  }, 1200); // adjust to 1000 or more if needed
});


document.addEventListener("DOMContentLoaded", () => {
  const mainBtn = document.querySelector(".main-add-to-cart");
  const stickyBtn = document.querySelector(".pdp-sticky-atc-button");

  if (!mainBtn || !stickyBtn) {
    console.warn("Main or Sticky button not found");
    return;
  }

  // hide sticky by default
  stickyBtn.style.display = "none";

  const toggleSticky = () => {
    const rect = mainBtn.getBoundingClientRect();
    const scrolledPast = rect.top < 0; // true only if main ATC is above the screen (scrolled past)

    if (scrolledPast) {
      stickyBtn.style.display = "block"; // show sticky
    } else {
      stickyBtn.style.display = "none"; // hide sticky
    }
  };

  // Run once on load and again on scroll/resize
  window.addEventListener("scroll", toggleSticky);
  window.addEventListener("resize", toggleSticky);
  toggleSticky();
});



